import React from 'react';
interface Option {
  value: string;
  label: string;
  icon?: React.ReactNode;
}
interface SegmentedControlProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}
export function SegmentedControl({
  options,
  value,
  onChange,
  className = ''
}: SegmentedControlProps) {
  return <div className={`inline-flex rounded-md shadow-sm bg-gray-100 p-1 ${className}`} data-id="element-3937">
      {options.map(option => <button key={option.value} type="button" className={`
            flex items-center px-4 py-2 text-sm font-medium rounded-md transition-all
            ${value === option.value ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}
          `} onClick={() => onChange(option.value)} data-id="element-3938">
          {option.icon && <span className="mr-2" data-id="element-3939">{option.icon}</span>}
          {option.label}
        </button>)}
    </div>;
}